export default "__VITE_ASSET__DWzKPhig__"